var moment = require('moment');
export function setDataGraficos(state,data){
  let por_hora = data.interacciones_por_hora.resultado.map(function(element){
    return {
      hora: element.hora+":00",
      value: element.cantidad
    }
  });
  state.interacciones_por_hora = por_hora;

  const contactos = data.conversaciones.contactos;
  let cantidad = 0;
  let conversaciones = data.conversaciones.conversaciones.map(function(element,index){    
    // if(nuevos_contactos[index]){
    //   cantidad = nuevos_contactos[index].cantidad;  
    // }else{
    //   cantidad = 0;
    // }

    return {
      y: element.hora+":00",
      a: element.cantidad,
      b: contactos[index].cantidad
    }
  });

  state.conversaciones = conversaciones;  
  state.promedios = data.promedios;
}

export function setFechaInicio(state,date){
  let x = moment(date).format('D-M-YYYY');
  state.fecha_inicio = x;  
}

export function setFechaFinal(state,date){
  let x = moment(date).format('D-M-YYYY');
  state.fecha_final = x;  

}
